import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import ShareProfileCardUpgradeModal from "./share-profile-card-upgrade-modal";

export default function ShareProfileCardUpsellButton({
  onStartFreeTrial,
  onSubscribe,
  showStartFreeTrial,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-2"
      >
        <FontAwesomeIcon icon={faShareNodes} className="h-4" />
        Share Profile Card
      </button>
      <ShareProfileCardUpgradeModal
        open={open}
        onClose={() => setOpen(false)}
        onStartFreeTrial={() => {
          setOpen(false);
          onStartFreeTrial?.();
        }}
        onSubscribe={() => {
          setOpen(false);
          onSubscribe?.();
        }}
        showStartFreeTrial={showStartFreeTrial}
      />
    </>
  );
}
